import { render, staticRenderFns } from "./CurrencyRate.vue?vue&type=template&id=7b39571c&"
import script from "./CurrencyRate.vue?vue&type=script&lang=ts&"
export * from "./CurrencyRate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports